/**
 * this handling of creating loading, toast
 */

import { LoadingController, ToastController} from '@ionic/angular';
import { Injectable } from '@angular/core';
import { StorageService } from '@app/services/storage.service';


@Injectable({
    providedIn: 'root',
})
export class ControlUtils {
    constructor(private loadingController: LoadingController,
                private storageService: StorageService,
                private toastController: ToastController) {  }

    async presentLoading(message= '') {
        const loading = await this.loadingController.create({
            message,
            translucent: true,
            spinner: 'dots'
        });
        await loading.present();
        return loading;
    }
    async stopPresentLoading() {
        // Make sure there is loading overlay to stop
        const loadingIndicator = await this.loadingController.getTop();
        if (loadingIndicator) {
            await this.loadingController.dismiss();
        }
    }

    async presentToast(message, color, duration, position) {
        let cssClass = '';
        let icon = 'alert-circle-outline'
        switch (color) {
            case 'success':
                cssClass = 'custom-success';
                icon = 'checkmark-circle'
                break;
            case 'danger':
                cssClass = 'custom-danger';
                break;
        }
        if (!this.storageService.isRefreshing) {
            const toast = await this.toastController.create({
                message,
                duration,
                position,
                cssClass,
                icon,
              });
            toast.present();
        }
    }
}
